import { render, staticRenderFns } from "./ScriptCreation.vue?vue&type=template&id=13a75eb0&scoped=true"
import script from "./ScriptCreation.vue?vue&type=script&lang=js"
export * from "./ScriptCreation.vue?vue&type=script&lang=js"
import style0 from "./ScriptCreation.vue?vue&type=style&index=0&id=13a75eb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a75eb0",
  null
  
)

export default component.exports